export const LIST_TABS = [
    {
        code: 'ACTIVE_RULES',
        label: $filter('translate')('Active rules'),
    },
    {
        code: 'INACTIVE_RULES',
        label: $filter('translate')('Inactive rules')
    }
]

export const TIER_PAYMENT_TYPE = {
    FIXED_RATE: {
        id: "FIXED_RATE",
        name: $filter('translate')('Fixed amount'),
        isIconPositionStart: true,
        ruleOffsetLabel: $filter('translate')('per hour when the open shift starts in'),
    },
    PAY_RATE_PERCENTAGE: {
        id: "PAY_RATE_PERCENTAGE",
        name: $filter('translate')('Percentage'),
        isIconPositionStart: false,
        ruleOffsetLabel: $filter('translate')('of the employee\'s hourly rate when the open shift starts in'),
    },
};

window.DURATION_THRESHOLD_VALUES = {
    SEVENTY_TWO_HOURS: 72*3600,
    FOURTY_EIGHT_HOURS: 48*3600,
    TWENTY_FOUR_HOURS: 24*3600,
    TWELVE_HOURS: 12*3600,
};

window.TIER_RULE_OFFSET = {
    [DURATION_THRESHOLD_VALUES.SEVENTY_TWO_HOURS]: {
        id: 'SEVENTY_TWO_HOURS',
        description: `72 ${$filter('translate')('hrs')}`,
        number: '72',
        value: DURATION_THRESHOLD_VALUES.SEVENTY_TWO_HOURS,
    },
    [DURATION_THRESHOLD_VALUES.FOURTY_EIGHT_HOURS]: {
        id: 'FOURTY_EIGHT_HOURS',
        description: `48 ${$filter('translate')('hrs')}`,
        number: '48',
        value: DURATION_THRESHOLD_VALUES.FOURTY_EIGHT_HOURS,
    },
    [DURATION_THRESHOLD_VALUES.TWENTY_FOUR_HOURS]: {
        id: 'TWENTY_FOUR_HOURS',
        description: `24 ${$filter('translate')('hrs')}`,
        number: '24',
        value: DURATION_THRESHOLD_VALUES.TWENTY_FOUR_HOURS,
    },
    [DURATION_THRESHOLD_VALUES.TWELVE_HOURS]: {
        id: 'TWELVE_HOURS',
        description: `12 ${$filter('translate')('hrs')}`,
        number: '12',
        value: DURATION_THRESHOLD_VALUES.TWELVE_HOURS,
    },
};

export const CENTS = 100.0;

export const FORM_MODES = {
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    COPY: 'COPY',
};